import React from "react";
import UserManagement from "components/Admin/UserManagement";
import AdminThemeProvider from "components/Admin/AdminThemeProvider";
import "./AdminDashboardPage.css";

const AdminDashboardPage = () => {
  return (
    <AdminThemeProvider>
      <div className="admin-dashboard-page-container">
        <UserManagement />
      </div>
    </AdminThemeProvider>
  );
};

export default AdminDashboardPage;
